<template>
  <td
    slot-name="default"
    :class="cellClass"
    class="ds-control ds-no-padding ds-table-layout-cell"
    :c-index="rowIndex + ',' + cellIndex"
    :rowspan="rowspan"
    :colspan="colspan"
    :align="cellAttr.align"
    :valign="cellAttr.valign"
    @dblclick="dblClickHandler">
    <slot name="default">
      <template v-if="isDesign">
        <DsfTextContentEditable style="padding:5px" v-model="text" :editable.sync="conentEditable" @input="textChangeHandler()" @blur="textChangeHandler"></DsfTextContentEditable>
      </template>
      <template v-else>
        <span v-html="dsf.safe.xss(text)"></span>
      </template>
    </slot>
  </td>
</template>
<script>
export default dsf.component({
  name: "DsfTableCell",
  ctrlCaption: "表格布局单元格",
  mixins: [$mixins.layout],
  inject: {
    $tableLayout: {
      default: null
    },
    $tableRow: {
      default: null
    }
  },
  props: {
    slots: {
      type: Array,
      default() {
        return [{ name: "default", controls: [] }];
      }
    },
    isOnce: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default() {
        return "auto";
      }
    },
    rowspan: {
      type: Number,
      default: 1
    },
    colspan: {
      type: Number,
      default: 1
    },
    cellIndex: {
      type: Number,
      default: 0
    },
    rowIndex: {
      type: Number,
      default: 0
    },
    cellAttr: {
      type: Object,
      default() {
        return {
          align: "", // 水平对齐
          valign: "" // 垂直对齐
        };
      }
    },
    cellStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    cellBorderStyle: {
      type: Object,
      default() {
        return {};
      }
    },
    text: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      conentEditable: false
    };
  },
  computed: {
    cellWidth() {
      let w = this.width;
      if (this.colspan > 1) {
        return "auto";
      } else {
        return w === "number" ? w + "px" : w || "auto";
      }
    },
    cellRealStyle() {
      let {cellWidth, rowIndex, cellIndex, rowspan, colspan, cellStyle, cellBorderStyle} = this;
      let {borderWidth, borderStyle, borderColor, noInsideBorder, outBorderShowSite, columnsInfo, rows} = this.$tableLayout;
      let res = {width: cellWidth};
      if (noInsideBorder) {
        res["border"] = this.isDesign ? '1px dashed #000' : 'none';
        return res;
      }
      if (borderWidth) {
        res["border-width"] = this.unitSize(borderWidth);
      }
      if (borderStyle && borderStyle != "none") {
        borderStyle === "double" && (borderStyle = "solid");
        res["border-style"] = borderStyle;
      }
      if (borderColor) {
        res["border-color"] = borderColor;
      }

      Object.assign(res, cellStyle, cellBorderStyle);

      if (rowIndex == 0 && outBorderShowSite.indexOf('top') === -1) {
        res['border-top-style'] = 'none';
      }
      if (cellIndex == 0 && outBorderShowSite.indexOf('left') === -1) {
        res['border-left-style'] = 'none';
      }
      if (rowIndex + rowspan == rows.length && outBorderShowSite.indexOf('bottom') === -1) {
        res['border-bottom-style'] = 'none';
      }
      if (cellIndex + colspan == columnsInfo.length && outBorderShowSite.indexOf('right') === -1) {
        res['border-right-style'] = 'none';
      }

      if (this.isDesign) {
        _.each(res, (v, k) => {
          if (v === "none") {
            res[k] = "dashed";
          }
        });
      }
      return res;
    },
    cellClass() {
      let css = _.clone(this.getCss);
      let res = this.$tableLayout.cellClass?.(this);
      if (dsf.isArray(res)) {
        css.push.apply(css, res);
      } else if (res) {
        css.push(res);
      }
      return css;
    }
  },
  watch: {
    'cellRealStyle': {
      handler(to) {
        this.$el && $(this.$el).removeAttr('style').css(to);
      },
      deep: true
    }
  },
  created() {
    if (this.isDesign) {
      this.createCellChildWatch();
    } else {
      if (this.$vm && this.local) {
        this.$tableRow.tableCells.push(this);
      }
    }
  },
  mounted() {
    $(this.$el).css(this.cellRealStyle);
  },
  beforeDestroy() {
    if (!this.isDesign) {
      dsf.array.remove(this.$tableRow.tableCells, this);
    }
  },
  methods: {
    createCellChildWatch() {
      let slot = _.find(this.slots, (it) => {
        return it.name == "default";
      });
      if (slot) {
        this.$watch(
          function () {
            return slot.controls;
          },
          (v, ov) => {
            this.slotControlsChange(v);
          }
        );
      }
    },
    $slotControlsChange(ctrl, slot) {
      this?.$tableLayout?.$childComponentAddToCell?.(this, ctrl, slot);
    },
    dblClickHandler(event) {
      if (this.isDesign) {
        if (!this.conentEditable) {
          this.conentEditable = true;
          this.$nextTick(() => {
            dsf.designer.beginEditTextConent(event.currentTarget);
          });
        }
      }
    },
    textChangeHandler() {
      if (this.isDesign) {
        this.$nextTick(() => {
          this.$tableLayout.updateRangeWrap();
        });
      }
    },
    slotControlsChange(v) {}
  }
});
</script>
